import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Arc, db } from "../services/db";
import { challenges } from "../utils/challenges";
import ColorPicker from "./ColorPicker";
import { ColorResult } from "react-color";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ChallengeDetails: React.FC = () => {
  const { challengeId } = useParams<{ challengeId: string }>();
  const [challenge, setChallenge] = useState<any | null>(null);

  const [selectedChallenge, setSelectedChallenge] = useState<Arc | null>(null);
  const [startDate, setStartDate] = useState<any>(null);
  const [color, setColor] = useState<ColorResult>({
    rgb: { r: 241, g: 112, b: 19, a: 1 },
    hex: "#F17013",
    hsl: { h: 28.235294117647058, s: 0.87, l: 0.51, a: 1 },
  });
  let newHabits: any[] = [];
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(`/browsechallenges/`);
  };

  const getChallengeById = (challenges: any[], arcId: string): any | null => {
    try {
      // Find the challenge with the specified arcId
      const foundChallenge = challenges.find(
        (challenge) => challenge.arcId === arcId
      );
      return foundChallenge || null;
    } catch (error) {
      console.error("Error fetching challenge by ID:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchChallenge = async () => {
      try {
        // Fetch the challenge details using the challenge ID
        const fetchedChallenge = await getChallengeById(
          challenges,
          challengeId!
        );
        console.log("fetchedChallenge: ", fetchedChallenge, challengeId);
        setChallenge(fetchedChallenge);
      } catch (error) {
        console.error("Error fetching challenge:", error);
      }
    };

    fetchChallenge();
  }, []);

  function convertChallengeIntoDb(selectedChallenge: Arc) {
    const habits = selectedChallenge.habits;
    console.log("h: ", habits);
    let newHabitObject: any = {};
    habits.forEach((challenge: any) => {
      let count = 0;
      newHabitObject = {
        id: uuidv4(),
        arcId: selectedChallenge.arcId,
        name: challenge,
        color: selectedChallenge.color,
        timeOfDay: { hour: "10", minute: "10" },
        completed: {},
      };

      let date = new Date(startDate); // Initialize date with the startDate value

      while (count < Number(selectedChallenge.timePeriod)) {
        count++;
        const dateString = date.toLocaleDateString();
        newHabitObject.completed[dateString] = false;
        // Move to the next date
        date.setDate(date.getDate() + 1);
      }

      // Add the new habit to the state
      // setHabits([...newHabits, newHabitObject]);
      newHabits = [...newHabits, newHabitObject];
    });
    return newHabits;
  }

  const handleStartChallenge = async () => {
    //   if (selectedChallenge) {
        console.log("selected: ", challenge);
      const newHabits2 = convertChallengeIntoDb(challenge);
      console.log("habitsss: ", newHabits2);
      await db.addArc(
        challenge.name,
        challenge.arcId,
        challenge.timePeriod,
        startDate,
        newHabits2,
        color.hex
      );
      console.log("Starting the challenge...");
    // }
    navigate("/myarcs");
  };

  //   if (!challengeId) {
  //     return <div>Loading...</div>; // Add a loading indicator while fetching the challenge
  //   }

  return (
    <div>
      {challenge ? (
        <div className="w-full">
          <button
            className="text-blue-600 btn ml-4  mt-4 items-center gap-1 mb-4 text-left flex justify-start px-4"
            onClick={handleBackClick}
          >
            <i data-feather="arrow-left-circle"></i>
            Back to Challenges
          </button>
          <h2 className="text-2xl text-center font-bold mb-4">
            {challenge.name}
          </h2>
          <p className="text-xl text-left pl-4 text-gray-600 mb-4">
            <b>Duration: </b>
            {challenge.timePeriod} days
          </p>

          <h3 className="text-xl text-left pl-4 font-bold mb-2">Habits:</h3>
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            {challenge.habits.map((habit: any, index: number) => (
              <div
                key={index}
                className="bg-slate-300 mx-5 flex shadow-md rounded-md p-4 mb-4 transition duration-300 ease-in-out transform hover:scale-80"
              >
                <p className="text-md font-bold">{habit}</p>
                {/* Add completion status if available */}
              </div>
            ))}
          </div>
          <div className="flex gap-2 items-center pt-10 pl-4">
            <div className="flex items-center gap-2">
              <DatePicker
                selected={startDate}
                onChange={(date: Date) => setStartDate(date)}
                className="input input-bordered block w-full"
                placeholderText="Select start date..."
                dateFormat="dd MMMM yyyy"
                todayButton="Today"
                shouldCloseOnSelect={true}
                required
              />
              <br />
              <p>Color:</p>
              <ColorPicker color={color} setColor={setColor} />
              <br />
            </div>
            <button
              className="btn btn-secondary"
              onClick={handleStartChallenge}
              disabled={!startDate}
            >
              Start the Challenge
            </button>
          </div>
        </div>
      ) : (
        <p>No Challenge Found</p>
      )}
    </div>
  );
};

export default ChallengeDetails;
